import { useMutation } from '@zg-rentals/react-query5';
import { useDispatch } from 'react-redux';

import useRequestConfig from '../../hooks/useRequestConfig';

import makeRequest from '../../utils/makeRequestUtils';

import StringConstants from '../../constants/StringConstants';
import { RENTAL_MANAGER_API_V1_PREFIX } from '../../constants/RouteConstants';

export interface UseCloneListingDataProps {
  listingAlias: string;
  fullAddress: string;
  unit?: string;
}

export interface UseCloneListingSuccessDataResponse {
  listingAlias: string;
}

export interface UseCloneListingReturnDataProps {
  response?: UseCloneListingSuccessDataResponse | undefined;
  success: boolean;
  httpStatus: number;
  error?: {
    code?: string | number;
    data: { duplicateListingAlias: string };
    httpStatus?: string | number;
    message: string;
  };
  errors?: string | null;
}

const API_PREFIX = `${RENTAL_MANAGER_API_V1_PREFIX}/users/properties/clone` as const;

const useCloneListing = (mutationOptions = {}) => {
  const dispatch = useDispatch();
  const requestConfig = useRequestConfig(StringConstants.GET);

  const queryFn = (data: UseCloneListingDataProps): Promise<UseCloneListingSuccessDataResponse> =>
    makeRequest<UseCloneListingReturnDataProps>({
      dispatch,
      endpoint: API_PREFIX,
      requestConfig,
      config: {
        params: { propertyId: data.listingAlias, fullAddress: data.fullAddress, unit: data?.unit },
      },
    });

  return useMutation({ mutationFn: async (data: UseCloneListingDataProps) => queryFn(data), ...mutationOptions });
};

export default useCloneListing;
